import React from "react";

const ASP_Folder = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Folder</h1>
      <p>This is the ASP Folder page content.</p>
    </div>
  );
};

export default ASP_Folder;
